import React from 'react'
import { useSelector } from 'react-redux'

import CloningStatusLabel from '../status/CloningStatusLabel'
import SessionName from './SessionName'
import { selectCloneLeaguesSessions } from '../../reducers/clone_leagues_sessions'

const SessionsTable = () => {
  const sessions = useSelector(selectCloneLeaguesSessions)

  return (<div className="cls-table-container">
    <table className="cls-table">
      <thead>
      <tr>
        <th className="cls-table-column-header">
          {window.I18n.t('clone_leagues_sessions.sessions_dashboard.session_name')}
        </th>
        <th className="cls-table-column-header">
          {window.I18n.t('clone_leagues_sessions.sessions_dashboard.date')}
        </th>
        <th className="cls-table-column-header">
          {window.I18n.t('clone_leagues_sessions.sessions_dashboard.created_by')}
        </th>
        <th className="cls-table-column-header">
          {window.I18n.t('clone_leagues_sessions.sessions_dashboard.number_of_leagues')}
        </th>
        <th className="cls-table-column-header">
          {window.I18n.t('clone_leagues_sessions.sessions_dashboard.status')}
        </th>
      </tr>
      </thead>
      <tbody>
      {sessions.map(session => (
        <tr key={session.id}>
          <td className="cls-table-data">
            <SessionName session={session}/>
          </td>
          <td className="cls-table-data">{session.created_at}</td>
          <td className="cls-table-data">{session.created_by}</td>
          <td className="cls-table-data">{Object.keys(session?.data?.leagues)?.length}</td>
          <td className="cls-table-data">
            <CloningStatusLabel
              status={session.status}
            />
          </td>
        </tr>
      ))}
      </tbody>
    </table>
  </div>)
}

export default SessionsTable
